<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="bg-primary m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Turnar Diligencia</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <turnar-dilgencia-form></turnar-dilgencia-form>
    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
        <button mat-button mat-dialog-close>Cancelar</button>
        <button mat-raised-button color="accent" (click)="edit()" [disabled]="!formValid">Turnar</button>
    </div>
</div>
